import {
  MediaGatewayState,
  MediaGatewayActionTypes,
  GET_MEDIA_GATEWAY_LIST,
  GET_MEDIA_GATEWAY_LIST_FULFILLED,
  GET_MEDIA_GATEWAY_PENDING,
  GET_MEDIA_GATEWAY_FULFILLED,
  SELECT_MEDIA_GATEWAY,
  CREATE_MEDIA_GATEWAY_PENDING,
  CREATE_MEDIA_GATEWAY_FULFILLED,
  DELETE_MEDIA_GATEWAY_FULFILLED,
  SET_MEDIA_GATEWAY_LOADING,
} from './mediaGateway.types';

export const initialState: MediaGatewayState = {
  entities: [],
  selected: [],
  single: null,
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  },
};

export default function mediaGatewayReducer(
  state = initialState,
  action: MediaGatewayActionTypes,
): MediaGatewayState {
  switch (action.type) {
    case GET_MEDIA_GATEWAY_LIST:
      return {
        ...state,
        selected: [],
      };

    case GET_MEDIA_GATEWAY_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: [],
      };

    case GET_MEDIA_GATEWAY_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_MEDIA_GATEWAY_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };

    case SELECT_MEDIA_GATEWAY:
      return {
        ...state,
        selected: action.payload || [],
      };

    case CREATE_MEDIA_GATEWAY_PENDING:
      return {
        ...state,
        createdId: null,
      };

    case CREATE_MEDIA_GATEWAY_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case DELETE_MEDIA_GATEWAY_FULFILLED:
      return {
        ...state,
        selected: [],
      };

    case SET_MEDIA_GATEWAY_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    default:
      return state;
  }
}
